import { useMemo } from 'react';

import { Media } from '@media-viewer';
import { useAtomValue } from 'jotai';

import { VisualizerMeasurements } from '@elva-visualizer';
import { activeVideosViewMapAtom, hasFullAnalysisAtom } from '@store';
import { Only, Above, Box, colors, Text } from '@ui';

import { PlaybackCell, VIDEO_TYPE } from '../PlaybackCell/PlaybackCell';

import { MobileVideos } from './MobileVideos';
import * as css from './SwingVideos.css';

const defaultViews = [1, 2] as const;

const EmptyVideo = () => (
    <Box
        width="100%"
        height="100%"
        style={{ backgroundColor: colors.black }}
        display={'flex'}
        justifyContent="center"
        alignItems="center"
    >
        <Text>No Video</Text>
    </Box>
);

export function SwingVideos() {
    const hasFullAnalysis = useAtomValue(hasFullAnalysisAtom);
    const activeVideos = useAtomValue(activeVideosViewMapAtom);

    const videos = useMemo(
        () =>
            defaultViews
                .map((view) => {
                    const videoType = VIDEO_TYPE.CURRENT;
                    const videosForAngle = activeVideos;
                    const video = videosForAngle[view];
                    return video
                        ? {
                              type: videoType,
                              ...video,
                          }
                        : undefined;
                })
                .filter((v) => !!v),
        [activeVideos],
    );

    return (
        <>
            <Above bp="lg" avoidRendering>
                <Box className={css.containerStyle}>
                    <Media.Layout rows={2} cols={1}>
                        {(videos.length &&
                            videos.map((video, index) =>
                                video ? (
                                    <PlaybackCell key={video.url} {...video} />
                                ) : (
                                    <EmptyVideo key={`empty-${index}`} />
                                ),
                            )) || (
                            <>
                                <EmptyVideo />
                                <EmptyVideo />
                            </>
                        )}
                    </Media.Layout>
                    {hasFullAnalysis && <VisualizerMeasurements />}
                </Box>
            </Above>
            <Only bp="sm" spans={2} avoidRendering>
                <MobileVideos />
            </Only>
        </>
    );
}
